import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api_base } from "../../env";
import axios from "axios";

const initialState = {
  loading: false,
  Produits: [],
  Magasins: [],
  Status: [],
  CategorysHashtags: [],
  RoulleteData: [],
};

export const GetProduits = createAsyncThunk("get produits", async () => {
  const response = await axios.get(`${api_base}produit/getProduits`);
  return response.data;
});

export const GetMagasin = createAsyncThunk("get Magasin", async () => {
  const response = await axios.get(`${api_base}magasin/getMagasin`);
  return response.data;
});

export const GetCategoryHashTags = createAsyncThunk(
  "GetCategoryHashTags",
  async () => {
    const response = await axios.get(`${api_base}CategoryHasTagsRoute/getAll`);
    return response.data;
  }
);

export const GetDataRoulleteByMagasin = createAsyncThunk(
  "get data Roullete by magasin  ",
  async (id) => {
    const response = await axios.get(`${api_base}reduction/getByMagasin/${id}`);
    return response.data;
  }
);
export const DataAppSlice = createSlice({
  name: "data app",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(GetProduits.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(GetProduits.fulfilled, (state, action) => {
      state.loading = false;
      state.Produits = action.payload;
    });
    builder.addCase(GetProduits.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(GetMagasin.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(GetMagasin.fulfilled, (state, action) => {
      state.loading = false;
      state.Magasins = action.payload;
      console.log(action.payload);
    });
    builder.addCase(GetMagasin.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(GetCategoryHashTags.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(GetCategoryHashTags.fulfilled, (state, action) => {
      state.loading = false;
      state.CategorysHashtags = action.payload;
    });
    builder.addCase(GetCategoryHashTags.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(GetDataRoulleteByMagasin.pending, (state, action) => {
      //  state.loading = true;
    });
    builder.addCase(GetDataRoulleteByMagasin.fulfilled, (state, action) => {
      //    state.loading = false;
      state.RoulleteData = action.payload;
    });
    builder.addCase(GetDataRoulleteByMagasin.rejected, (state, action) => {
      //state.loading = false;
    });
  },
});

export default DataAppSlice.reducer;
